import React, { useState } from 'react';
import Navbar from "./Navbar.jsx"
import Home from "./Home";
import About from "./About";
import Services from "./Services";
import CaseStudies from "./CaseStudies";
import Team from "./Team";
import Launch from "./Launch";
import Contact from "./Contact";
import ContactModal from "./ContactModal";

function MainPage() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <Navbar onContactClick={openModal} />
            <Home onContactClick={openModal} />
            <About />
            <Services />
            <CaseStudies />
            <Team />
            <Launch />
            <Contact onContactClick={openModal} />
            
            <ContactModal isOpen={isModalOpen} onClose={closeModal} />
        </>
    );
}

export default MainPage;
